import { useCallback } from 'react'

import { type ConversationStartContext } from '../../business-logic/types/ConversationTurnPayload'
import { GUIDED_INTAKE_EVENTS } from '../../constants'
import { useGlobalSearch } from '../../providers/GlobalSearchProvider'
import { getGuidedIntakePageType } from '../../utils/getGuidedIntakePageType'
import { ConversationBootstrapModes } from '../useConversationStream'

export const useStartGuidedIntake = () => {
  const { openConversation } = useGlobalSearch()

  return useCallback(
    (startContext: ConversationStartContext) => {
      window.analytics?.track(GUIDED_INTAKE_EVENTS.ENTRY_POINT_CLICKED, {
        entry_point: startContext.entryPoint,
        page_type: getGuidedIntakePageType(),
      })
      openConversation({
        mode: ConversationBootstrapModes.NEW,
        initialQuery: '',
        startContext,
      })
    },
    [openConversation]
  )
}
